<script lang="ts" setup>
import { LIMIT_HOTMATCH_ITEM } from '~/constants'
import { HOT_MATCH_ITEM_DEFAULT } from '~/resources/sports'

const { fetchHotmatches, hotmatches, isLoading } = useSports()
const CLASS_SCROLL = 'remove-scrollbar-bar'
const scrollContainer = ref<HTMLElement | null>(null)
const customClass = ref('')

fetchHotmatches()

const onScroll = () => {
  const el = scrollContainer.value
  if (el) {
    const isBottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1
    if (isBottom) {
      customClass.value = CLASS_SCROLL
    } else {
      customClass.value = ''
    }
  }
}
</script>

<template>
  <div :class="['scrollbar-bar', customClass]">
    <div ref="scrollContainer" class="home-hot-match" @scroll="onScroll">
      <template v-if="hotmatches?.length && !isLoading">
        <BaseHotmatch
          v-for="hotmatch in hotmatches"
          :key="hotmatch.matchId"
          :hotmatch="hotmatch"
        />
      </template>
      <template v-if="!hotmatches?.length && !isLoading">
        <BaseHotmatch
          v-for="index in LIMIT_HOTMATCH_ITEM"
          :key="index"
          :hotmatch="HOT_MATCH_ITEM_DEFAULT"
        />
      </template>
      <BaseSkeleton v-if="isLoading" width="310px" height="310px" />
    </div>
  </div>
</template>
<style scoped lang="scss">
@import '~/assets/styles/components/desktop/home/hot-match.scss';
</style>
